/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconShip3 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M1.5 17.25V7.5a2.25 2.25 0 1 1 4.5 0v5.25M18 12.75V7.5a2.25 2.25 0 1 1 4.5 0v9.75M6 7.5v-.75a6 6 0 1 1 12 0v.75" />
        <path d="M21 21.75a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-1.5c0-.472.222-.917.6-1.2l4.2-3.15A3.002 3.002 0 0 0 9 13.5V8.41a3.07 3.07 0 0 1 2.98-3.159L12 5.25a3 3 0 0 1 3 3v5.25c0 .944.445 1.833 1.2 2.4l4.2 3.15c.378.283.6.728.6 1.2v1.5zM11.25 9h1.5M12 18.75v4.5" />
      </g>
    </svg>
  ),
);
